import React from "react";

import clsx from "clsx";

import Alert from "@busbud/design-system-components/dist/Alert";

interface Props {
  className?: string;
  contractor_name: string | null;
  operator_disclaimers: string[] | null;
}

const OperatorDisclaimers: React.FC<Props> = props => {
  const { className, contractor_name, operator_disclaimers } = props;
  if (!contractor_name && !operator_disclaimers) {
    return null;
  }

  const disclaimers = operator_disclaimers || [];
  const warnings = [contractor_name, ...disclaimers].filter(
    (warning): warning is string => !!warning
  );

  if (warnings.length === 0) {
    return null;
  }

  return (
    <div
      data-borderred="true"
      className={clsx("flex flex-col gap-200", className)}
    >
      {warnings.map((text, index) => (
        <Alert key={index} severity="notice">
          {text}
        </Alert>
      ))}
    </div>
  );
};

export default OperatorDisclaimers;
